export default __webpack_public_path__ + "static/media/KMnOsolution.4bbb2755.jpg";